module.exports = __webpack_public_path__ + "media/images/locations/basel-4cca9d2e877333c9faad40421e59c8bd.jpg";